import { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useGamificationStore } from '../../stores/gamification-store';
import { useRumioBalance } from '../../pages/public/deals/hooks/useRumios';
import { useLanguage } from '../../contexts/LanguageContext';
import ProfileBadge from '../common/ProfileBadge';
import ProfileMenu from '../common/ProfileMenu';
import AnimatedRumioIcon from '../common/AnimatedRumioIcon';

export default function AccountLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { xp, level } = useGamificationStore();
  const { data: rumioBalance } = useRumioBalance();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Link to="/" className="flex items-center">
              <img src="/logo.svg" alt="RUMIO" className="h-8" />
            </Link>

            {/* Rumio/XP indicators + Profile badge */}
            <div className="flex items-center gap-2 sm:gap-3">
              {/* Rumio Balance */}
              <Link
                to="/deals"
                className="flex items-center gap-1.5 px-2 py-1 rounded-lg bg-amber-50 hover:bg-amber-100 transition-colors"
                title={t('header.rumioBalance', 'Your Rumio balance')}
              >
                <AnimatedRumioIcon balance={rumioBalance?.balance ?? 0} size="md" />
                <span className="text-sm font-semibold text-amber-700">
                  {rumioBalance?.balance ?? 0}
                </span>
              </Link>

              {/* XP/Level indicator */}
              <Link
                to="/account/profile"
                className="hidden sm:flex items-center gap-1.5 px-2 py-1 rounded-lg bg-primary-50 hover:bg-primary-100 transition-colors"
                title={t('header.levelXp', 'Level {{level}} - {{xp}} XP', { level, xp })}
              >
                <span className="text-sm">⭐</span>
                <span className="text-sm font-semibold text-primary-700">
                  {t('header.levelShort', 'Lv{{level}}', { level })}
                </span>
              </Link>

              <ProfileBadge onClick={() => setMenuOpen(true)} />
            </div>
          </div>
        </div>
      </header>

      {/* Profile Menu (unified navigation) */}
      <ProfileMenu
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
      />

      {/* Main content */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </div>
    </div>
  );
}
